module.exports = __webpack_public_path__ + "img/kitchen-dining-accent-decor.a517797.jpg";